import { createSelector } from 'reselect'
import { pagesSelector } from '../../selectors'

export const companyDashboardPageSelector = createSelector(pagesSelector, pages => pages.companyDashboard)
